(function () {
  'use strict';

  var loader = document.getElementById('customily-product-loader');
  var existing = window.CustomilyThemeProductLoader;
  var PROBE_TIMEOUT_MS = 2500;

  if (!loader) return;
  if (existing && existing.promise) return;

  var config = {
    shop: loader.getAttribute('data-shop') || '',
    productId: loader.getAttribute('data-product-id') || '',
    productHandle: loader.getAttribute('data-product-handle') || '',
    personalizeSrc: loader.getAttribute('data-personalize-src') || '',
    customilySrc: loader.getAttribute('data-customily-src') || '',
    unifiedSrc: loader.getAttribute('data-unified-src') || '',
    stickyCssSrc: loader.getAttribute('data-sticky-css-src') || '',
    stickyScriptSrc: loader.getAttribute('data-sticky-script-src') || ''
  };

  var controller = {
    state: 'checking',
    reason: '',
    promise: null,
    activateSticky: activateSticky
  };

  window.CustomilyThemeProductLoader = controller;
  setState('checking', 'probe-started');

  function setState(state, reason) {
    controller.state = state;
    controller.reason = reason || '';
    document.documentElement.setAttribute('data-customily-product', state);

    try {
      window.dispatchEvent(new CustomEvent('customily-theme-status', {
        detail: { state: state, reason: reason || '' }
      }));
    } catch (error) {
      // The data attribute remains available for diagnostics in older browsers.
    }
  }

  function buildProbeUrl() {
    return (
      'https://sh.customily.com/api/settings/unified/' +
      encodeURIComponent(config.productHandle) +
      '?shop=' + encodeURIComponent(config.shop) +
      '&productId=' + encodeURIComponent(config.productId)
    );
  }

  function isLinkedConfig(data) {
    var sets = data && Array.isArray(data.sets) ? data.sets : [];
    var productConfig =
      data && data.productConfig && typeof data.productConfig === 'object'
        ? data.productConfig
        : {};
    var assignedSets = Array.isArray(productConfig.assignedSets)
      ? productConfig.assignedSets
      : [];

    return (
      sets.some(function (set) {
        return set && set.linked !== false;
      }) ||
      assignedSets.length > 0 ||
      !!productConfig.initial_product_id
    );
  }

  function probeBinding() {
    return new Promise(function (resolve) {
      var settled = false;
      var timer;

      function finish(bound, reason) {
        if (settled) return;
        settled = true;
        window.clearTimeout(timer);
        resolve({ bound: bound, reason: reason });
      }

      if (
        typeof window.fetch !== 'function' ||
        !config.shop || !config.productId || !config.productHandle
      ) {
        finish(true, 'probe-unavailable');
        return;
      }

      timer = window.setTimeout(function () {
        finish(true, 'probe-timeout');
      }, PROBE_TIMEOUT_MS);

      window.fetch(buildProbeUrl(), {
        method: 'GET',
        mode: 'cors',
        credentials: 'omit',
        cache: 'no-store'
      }).then(function (response) {
        if (response.status === 404) {
          finish(false, 'not-linked');
          return;
        }

        if (!response.ok) {
          // Unknown server responses fail open so personalization never disappears.
          finish(true, 'probe-http-' + response.status);
          return;
        }

        return response.json().then(function (data) {
          var linked = isLinkedConfig(data);
          finish(linked, linked ? 'linked' : 'not-linked');
        }).catch(function () {
          finish(true, 'probe-invalid-json');
        });
      }).catch(function () {
        // Network and CORS failures also fail open for storefront safety.
        finish(true, 'probe-failed');
      });
    });
  }

  function loadStylesheet(src, id) {
    var link;
    if (!src || document.getElementById(id)) return;
    link = document.createElement('link');
    link.id = id;
    link.rel = 'stylesheet';
    link.href = src;
    document.head.appendChild(link);
  }

  function loadScript(src, id) {
    return new Promise(function (resolve, reject) {
      var script;
      var existingScript = document.getElementById(id);

      if (!src) {
        resolve();
        return;
      }

      if (existingScript) {
        if (existingScript.getAttribute('data-loaded') === 'true') {
          resolve();
          return;
        }
        existingScript.addEventListener('load', resolve, { once: true });
        existingScript.addEventListener('error', reject, { once: true });
        return;
      }

      script = document.createElement('script');
      script.id = id;
      script.src = src;
      script.async = false;
      script.defer = true;
      script.addEventListener('load', function () {
        script.setAttribute('data-loaded', 'true');
        resolve();
      }, { once: true });
      script.addEventListener('error', reject, { once: true });
      document.body.appendChild(script);
    });
  }

  function activateSticky() {
    var template = document.querySelector('[data-customily-sticky-template]');
    var existingRoot = document.querySelector('[data-customily-mobile-sticky-atc]');

    if (!existingRoot && template && template.content) {
      template.parentNode.insertBefore(template.content.cloneNode(true), template);
      template.parentNode.removeChild(template);
    }

    loadStylesheet(config.stickyCssSrc, 'customily-mobile-sticky-atc-styles');
    return loadScript(
      config.stickyScriptSrc,
      'customily-mobile-sticky-atc-runtime'
    ).catch(function () {
      // Sticky UI is optional; the core Customily flow must continue.
    });
  }

  function loadRuntime(result) {
    if (!result.bound) {
      setState('unbound', result.reason);
      return Promise.resolve(result);
    }

    setState(result.reason === 'linked' ? 'bound' : 'fallback', result.reason);
    activateSticky();

    // personlize.js must install its hooks before Customily applies store settings.
    return loadScript(config.personalizeSrc, 'customily-theme-integration')
      .catch(function () {
        // Fail open: Customily's native flow is preferable to no personalization.
      })
      .then(function () {
        return loadScript(config.customilySrc, 'customily-core-runtime');
      })
      .then(function () {
        return loadScript(config.unifiedSrc, 'customily-shopify-runtime');
      })
      .then(function () {
        setState('ready', result.reason);
        return result;
      })
      .catch(function () {
        setState('error', 'runtime-load-failed');
        return result;
      });
  }

  controller.promise = probeBinding().then(loadRuntime);

  document.addEventListener('shopify:section:load', function () {
    if (
      controller.state === 'bound' ||
      controller.state === 'fallback' ||
      controller.state === 'ready'
    ) {
      activateSticky();
    }
  });
})();
